"use client"

import { getFixedT } from "@/languages/i18n"
import { useState } from "react"
import { TransformedStoreItem } from "../types"
import StoreList from "./StoreList"
import StoreMap from "./StoreMap"

interface StoreLocatorContentProps {
  stores: TransformedStoreItem[]
  title?: string
  locale?: string
}

const StoreLocatorContent = ({ stores, title, locale }: StoreLocatorContentProps) => {
  const t = getFixedT(locale)
  const [selectedStore, setSelectedStore] = useState<TransformedStoreItem | null>(stores.length > 0 ? stores[0] : null)

  const handleStoreClick = (store: TransformedStoreItem) => {
    setSelectedStore(store)
  }

  if (stores.length === 0) {
    return (
      <div className="w-full flex items-center justify-center py-20">
        <p className="text-[14px] leading-[21.7px] text-[#333]">{t("No stores available")}</p>
      </div>
    )
  }

  return (
    <div className="w-full flex flex-col">
      {title && (
        <h2 className="sm:text-2xl text-lg leading-[27.9px] font-bold text-[#333] sm:mb-8 mb-5 uppercase">{title}</h2>
      )}
      <div className="flex flex-col-reverse sm:flex-row h-full">
        <StoreList stores={stores} selectedStoreId={selectedStore?.id || null} onStoreClick={handleStoreClick} locale={locale} />
        <StoreMap stores={stores} selectedStore={selectedStore} locale={locale} />
      </div>
    </div>
  )
}

export default StoreLocatorContent
